import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { workerApi, type WorkerStatus, type WorkerSummary } from '../lib/api';

export default function Dashboard() {
  const { user } = useAuth();
  const [status, setStatus] = useState<WorkerStatus | null>(null);
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState<WorkerSummary | null>(null);
  const [err, setErr] = useState<string | null>(null);

  function load() {
    workerApi.status().then(setStatus).catch(() => setStatus(null));
  }
  useEffect(() => { load(); }, []);

  async function onRun(dry: boolean) {
    setRunning(true); setErr(null); setResult(null);
    try {
      const r = await workerApi.runNow(dry);
      if ('skipped' in r) setErr(`Воркер уже запущен (${r.skipped}). Подожди тик.`);
      else { setResult(r); load(); }
    } catch (e) {
      setErr(String((e as Error)?.message ?? e));
    } finally {
      setRunning(false);
    }
  }

  return (
    <div className="container">
      <h2>Добро пожаловать{user?.display_name ? `, ${user.display_name}` : ''}</h2>
      <p className="muted">Роль: {user?.role}</p>

      <div className="card form" style={{ marginTop: 16 }}>
        <h3>Воркер каждый час</h3>
        {status ? (
          <div className="kv">
            <span>Включён:</span>     <span>{status.enabled ? '✓' : '—'}</span>
            <span>Cron:</span>        <span><code>{status.cron}</code></span>
            <span>Сейчас работает:</span> <span>{status.running ? '✓' : '—'}</span>
            <span>Последний прогон:</span> <span>{status.last?.finished_at ?? <span className="muted">не было</span>}</span>
            {status.last && (
              <>
                <span>Длительность:</span> <span>{status.last.duration_ms} ms</span>
                <span>Товаров:</span>     <span>{status.last.total_products}</span>
                <span>Stayed open:</span> <span>{status.last.stayed_open}</span>
                <span>Open → closed:</span> <span>{status.last.open_to_closed}</span>
                <span>Closed → open:</span> <span>{status.last.closed_to_open}</span>
                <span>Батчей:</span>      <span>{status.last.batches?.length ?? 0}</span>
              </>
            )}
          </div>
        ) : <p className="muted">Загрузка…</p>}

        {user?.role === 'admin' && (
          <div className="row" style={{ marginTop: 14 }}>
            <button className="btn" disabled={running} onClick={() => onRun(true)}>
              {running ? 'Считаем…' : 'Прогон без отправки (dry-run)'}
            </button>
            <button className="btn primary" disabled={running} onClick={() => onRun(false)}>
              {running ? 'Запущен…' : 'Запустить воркер сейчас'}
            </button>
          </div>
        )}
        {err && <div className="error" style={{ marginTop: 10 }}>{err}</div>}

        {result && (
          <pre className="raw" style={{ marginTop: 12 }}>{JSON.stringify(result, null, 2)}</pre>
        )}
      </div>

      <p className="muted" style={{ marginTop: 18 }}>Куда дальше:</p>
      <ul>
        {user?.role === 'admin' && <li><Link to="/sellers">Продавцы</Link> и их Flowwow-токены</li>}
        <li><Link to="/schedules">Расписания отгрузок</Link></li>
        <li><Link to="/products">Товары</Link></li>
        <li><Link to="/prices/imports">Загрузка прайсов</Link></li>
        <li><Link to="/publish-log">Лог публикаций</Link></li>
      </ul>
    </div>
  );
}
